// extracted by mini-css-extract-plugin
export default {"mainText":"Users_mainText__qkps5","btnCustom":"Users_btnCustom__oDDU1","page":"Users_page__NRlHP","inp":"Users_inp__zhKc-"};